import { CommonTrainInfoFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoForm";
import { CommonSubTypeProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoFormModal";
import { AffectedStopsFields } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/AffectedStopsFields";
import { TrainContext } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/utils/formContextWrappers";
import { EitherTrainFormSchema } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { clamp } from "features/CenterContent/shared/utils";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "shared/components/Spor";
import { RenderErrorInPath } from "shared/components/forms/RenderErrorInPath";

const MIN_VALUE = 0;
const MAX_VALUE = 60 * 24;

type DelayTypeFieldProps = {
  label: string;
  delayFieldKey: "delayInMinutes" | "minutesLate";
};

export const TrainDelayTypeFields: FC<
  CommonTrainInfoFormProps &
    CommonSubTypeProps &
    TrainContext &
    DelayTypeFieldProps
> = (props) => {
  const { trainFormPrefix, label, delayFieldKey } = props;
  const { getValues, setValue, register, formState } =
    useFormContext<EitherTrainFormSchema>();
  const { errors } = formState;

  const delayFieldPath = `${trainFormPrefix}.${delayFieldKey}` as const;

  return (
    <>
      <AffectedStopsFields {...props} />
      <Input
        type="number"
        label={label}
        step={1}
        {...register(delayFieldPath)}
        value={
          getValues(delayFieldPath) ||
          "" /* Show the field as empty if the value is 0 or missing */
        }
        onChange={(e) => {
          if (e.target.value) {
            setValue(
              delayFieldPath,
              clamp(MIN_VALUE, MAX_VALUE, parseInt(e.target.value, 10)),
            );
          } else {
            setValue(delayFieldPath, 0);
          }
        }}
        width={`${label.length}ch`}
      />
      <RenderErrorInPath errors={errors} errorPath={delayFieldPath} />
    </>
  );
};

export const TrainDelayed: FC<
  CommonTrainInfoFormProps & CommonSubTypeProps & TrainContext
> = (props) => {
  const { t } = useTranslation();
  return (
    <TrainDelayTypeFields
      label={t("Forsinkelse (min)")}
      delayFieldKey="delayInMinutes"
      {...props}
    />
  );
};
